var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67547 7.89299L8.04684 9.6185C8.42279 9.89805 8.93369 9.5221 8.7891 9.07868L7.88296 6.2928L10.2254 4.62513C10.611 4.35522 10.4182 3.74791 9.94586 3.74791H7.07323L6.13817 0.836721C5.99358 0.393294 5.367 0.393294 5.2224 0.836721L4.27771 3.74791H1.40508C0.932729 3.74791 0.739935 4.35522 1.12552 4.62513L3.46797 6.2928L2.56184 9.07868C2.41725 9.5221 2.92815 9.88841 3.3041 9.6185L5.67547 7.89299Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0cf1943aa828520a0de7dcc45cda8079.svg";
export { ForwardRef as ReactComponent };